<div id="fixedLogout">
    <a (click)="onLogout()"
        ><span class="logout_icon"><span class="icon-arrow-circle-o-left"></span></span
        ><span class="logout_label">Logout</span></a
    >
</div>
